$.extend({
  // 网页链接更改相关函数
  UrlChange: {
    // 获取所有 参数
    params: function () {
      var query = location.search.substr(1);
      query = query.split("&");
      var params = {};
      for (let i = 0; i < query.length; i++) {
        let q = query[i].split("=");
        if (q.length === 2) {
          params[q[0]] = decodeURI(q[1]);
        }
      }
      return params;
    },
    // 更改当前链接
    change: function (dic) {
      history.replaceState(
        {
          page: 0,
        },
        "1.html",
        "?" +
          $.map(dic, function (item, key) {
            return key + "=" + item;
          }).join("&")
      );
    },
  },
  // 全局打印
  Log: function () {
    let debug = this.UrlChange.params().debug;
    if (!debug) return;
    let _text = $.map(new Array(arguments.length), function (i, k) {
      return "arguments[" + k + "]";
    }).join(",");
    if (debug == "all") {
      eval("console.log(" + _text + ")");
      console.trace();
    } else if (JSON.stringify(arguments).indexOf(debug) != -1) {
      eval("console.log(" + _text + ")");
      console.trace();
    }
  },
  // 拷贝到 剪贴板
  Copy: function (text) {
    const elem = document.createElement("textarea");
    elem.style.opacity = "0";
    elem.style.position = "absolute";
    elem.value = text;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand("copy");
    document.body.removeChild(elem);
  },
  // 提示栏
  Msg: async function (level, msg) {
    let icon = [
      "https://cdn.shopify.com/s/files/1/0759/9724/9823/files/info_tip_3ffd1f3f-6372-49e1-ab3b-7772c6e0bb19.svg?v=1687332245",
      "https://cdn.shopify.com/s/files/1/0759/9724/9823/files/warning_tip_9273dfaa-8bc4-42a3-9ea2-11d9f727af4b.svg?v=1687332245",
      "https://cdn.shopify.com/s/files/1/0759/9724/9823/files/error_tip_ad3288c7-b917-4350-988e-feeb87663479.svg?v=1687332244",
    ];
    let levelStyle = [
      "background: #E8FFEA;border: 1px solid #009A29;",
      "background: #FFF7EC;border: 1px solid #FF8300;",
      "background: #FFEEEE;border: 1px solid #F53F3F;",
    ];
    let style =
      "@keyframes tiptop{0%{opacity:0;transform:translate(-50%,calc(-50% + 10px))}100%{opacity:1;transform:translate(-50%,-50%)}}.copy_tip{position:fixed;left:50%;top:20%;transform:translate(-50%,-50%);display:flex;align-items:center;justify-content:center;padding:12px 30px;border-radius:26px;animation:unset;opacity:0;z-index:6;pointer-events:none}.copy_tip .icon{display:inline-flex;margin-right:13px;width:20px;height:20px}.copy_tip span{font-style:normal;font-weight:600;font-size:20px;line-height:28px;color:#344054}.copy_tip.active{animation:tiptop 0.3s linear 0s 1 normal;animation-fill-mode:forwards}@media screen and (max-width:960px){.copy_tip{padding:10px 20px;border-radius:21px;left:50%;top:20%}.copy_tip .icon{margin-right:17px}.copy_tip span{font-size:16px;line-height:22px;white-space:nowrap}}";
    let html =
      '<div class="copy_tip"><div class="icon"></div><span>' +
      msg +
      "</span></div>";
    let div = $("body").find(".copy_tip");
    if (!div.length) {
      $("body")
        .append(html)
        .append("<style>" + style + "</style>");

      return this.msg(level, msg);
    }

    div.attr("style", levelStyle[level]);
    div.find(".icon").css({
      background: `url(${icon[level]}) no-repeat`,
      "background-size": "100%",
    });
    div.addClass("active");
    setTimeout(function () {
      div.removeClass("active");
    }, 3000);
  },
  // 异步请求
  AjaxPromise: async function (data, success, error) {
    // 异步ajax处理方式
    // data: ajax执行的内容
    // success: ajax执行成功执行函数
    // error: ajax执行失败执行函数
    function inner() {
      const p = new Promise((resolve, reject) => {
        data.success = function (result) {
          resolve(result);
        };
        data.error = function (result) {
          reject(result.responseJSON);
        };
        $.ajax(data);
      });
      return p;
    }
    try {
      const data = await inner();
      success ? success(data) : "";
      return data;
    } catch (e) {
      error ? error() : "";
      return e;
    }
  },
  // 时间相关通用函数
  Times: {
    // 获取格式化时间
    str: function (times) {
      let b = function (a) {
        if (("" + a).length >= 2) {
          return a;
        }
        return "0" + a;
      };
      if (!times) {
        times = this.ctime();
      }
      let d = new Date(times * 1000);
      return (
        d.getFullYear() +
        "-" +
        b(d.getMonth() + 1) +
        "-" +
        b(d.getDate()) +
        " " +
        b(d.getHours()) +
        ":" +
        b(d.getMinutes()) +
        ":" +
        b(d.getSeconds())
      );
    },
    // 字符串转时间戳
    ctime: function (str) {
      if (!str) {
        return parseInt(new Date().getTime() / 1000);
      }
      return parseInt(
        new Date(str.substring(0, 19).replace(/-/g, "/")).getTime() / 1000
      );
    },
    // 等待函数
    sleep: async function (time = 300) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
  },
  // 随机相关函数
  Ramdom: {
    // 随机ID
    ID: function () {
      return (
        new Date().getTime() +
        "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        })
      );
    },
    // 随机数
    randint: (min, max) => {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    // 打乱
    shuffle: (arr) => {
      let newArray = arr.slice(); // 使用slice方法复制原始数组
      for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
      }
      return newArray;
    },
  },
  // 列表其他函数
  List: {
    // 不改变顺序 列表去重
    set(arr) {
      return [...new Set(arr)];
    },
    // 列表拷贝
    copy: (arr) => {
      return arr.slice();
    },
    // 列表求和
    add: (arr) => {
      return arr.reduce((acc, cur) => acc + cur, 0);
    },
  },
  Str: {
    // 字符串反转
    reverse: (str) => {
      return str.split("").reverse().join("");
    },
    // 字符串 包含 另一个字符串
    in: (str1, str2) => {
      return str1.indexOf(str2) !== -1;
    },
    // 判断是否是邮箱
    isEmail: (str) => {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);
    },
    // 判断是否是链接
    isUrl: (str) => {
      return /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(
        str
      );
    },
    // 判断是否是时间
    isDate: (str) => {
      return !isNaN(Date.parse(str));
    },
    // 获取字符串中出现次数最多的单词
    maxWord: (str) => {
      const wordMap = {};
      let maxWord = "";
      let maxCount = 0;
      str
        .toLowerCase()
        .replace(/[^\w\s]/g, "")
        .split(" ")
        .forEach((word) => {
          if (wordMap[word]) {
            wordMap[word]++;
          } else {
            wordMap[word] = 1;
          }
          if (wordMap[word] > maxCount) {
            maxWord = word;
            maxCount = wordMap[word];
          }
        });
      return maxWord;
    },
  },
});
$(function () {
  try{
    $.map(onLoadFuncLis, (f) => {
      f();
    });
  }catch{
    
  }
});
